<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-6"
      v-model="form.stdInfo"
      :board="this.board"
      :date-readonly="false"
      :is-print="isPrint" />


    <!-- ※ 항목별 작성안내 -->
    <div>
      <h5>※ 항목별 작성안내</h5>
      <ol class="prefix-dot">
        <li>
          소속지원청 : 해당되는 지역청 기재<br>
          - 법학과는 해당 지역청 기재<br>
          - 교육지원청은 ‘00교육지원청’ 기재하고, 직속기관은 ‘본청’으로 기재
        </li>
        <li>설립구분 : 공립, 사립으로 구분하여 기재</li>
        <li>급 : 기계공학과, 초, 중, 고, 특수, 각종, 교육지원청, 기관</li>
        <li>학교(기관)명 : 작성자 정보에서 선택</li>
        <li>유해요인조사 실시일 : 유해요인조사 실시 일자(실시직종별 실시일자가 다른 경우는 가장 먼저 실시한 일자)</li>
      </ol>

      <h5>※ 실시방법</h5>
      <ol class="prefix-dot">
        <li>컨설팅 기관에 위탁하여 실시한 경우 : 컨설팅 기관 기재(예시 : 00안전보건, 00컨설팅)</li>
        <li>학교에서 자체적으로 실시한 경우 : 재실시</li>
      </ol>

      <h5>※ 실시직종 : 조리, 시설관리, 청소, 통학차량보조, 사무 업무에 대해 「근골격계부담작업 유해요인조사」 실시 여부</h5>
      <p>(표기방법)</p>
      <ol class="prefix-dot">
        <li>O(실시) : 유해요인조사 실시</li>
        <li>X(미실시) : 유해요인조사를 실시하지 않음</li>
        <li>부담작업 없음 : 실시직종에 「근골격계부담작업」 없음</li>
        <li>해당직종 없음 : 학교(기관)내 실시직종이 없음</li>
        <li>기타 : 선택사항에 해당이 안되는 경우로 ‘비고’란에 해당내용 기재</li>
      </ol>

      <h5 class="mb-8">※ 비고 : 실시일자가 다른 경우, 위탁사에서 실시한 경우 등 유해요인조사 실시와 관련된 사항 기재</h5>
    </div>

    <!-- 직종별 실시여부 -->
    <div class="flex justify-between items-center mt-6 mb-4">
      <h5><i class="dot"></i> 직종별 실시여부</h5>
    </div>
    <table class="w-full">
      <thead>
        <tr>
          <th rowspan="2">소속지원청</th>
          <th rowspan="2">설립구분</th>
          <th rowspan="2">급</th>
          <th rowspan="2">학교(기관)명</th>
          <th rowspan="2">유해요인조사<br>실시일</th>
          <th rowspan="2">실시방법</th>
          <th colspan="5" class="text-center">실시 직종</th>
          <th rowspan="2">비고</th>
        </tr>
        <tr>
          <th>조리</th>
          <th>시설</th>
          <th>청소</th>
          <th>통학차량보조</th>
          <th>사무직종(교원, 공무원 등)</th>
        </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <vs-select autocomplete v-model="form.소속지원청" class="w-full">
            <vs-select-item v-for="item in [
                      '서울특별시동부교육지원청',
                      '서울특별시서부교육지원청',
                      '서울특별시남부교육지원청',
                      '서울특별시북부교육지원청',
                      '서울특별시중부교육지원청',
                      '서울특별시강동송파교육지원청',
                      '서울특별시강서양천교육지원청',
                      '서울특별시강남서초교육지원청',
                      '서울특별시동작관악교육지원청',
                      '서울특별시성동광진교육지원청',
                      '서울특별시성북강북교육지원청',
                    ]" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <vs-select autocomplete v-model="form.설립구분" class="w-full">
            <vs-select-item v-for="item in ['공립','사립']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <vs-select autocomplete v-model="form.급" class="w-full">
            <vs-select-item v-for="item in ['기계공학과','초','중','고','특수','각종','교육지원청','기관']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <field-selector v-model="form.fieldId" class="w-full" @select="onSelectFieldSelector"/>
        </td>
        <td>
          <date-selector v-model="form.실시일" class="w-full" />
        </td>
        <td>
          <ml-textarea v-model="form.실시방법" class="w-full" />
        </td>
        <td>
          <vs-select autocomplete v-model="form.조리" class="w-full">
            <vs-select-item v-for="item in ['O','X','부담작업 없음','해당직종 없음','기타']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <vs-select autocomplete v-model="form.시설" class="w-full">
            <vs-select-item v-for="item in ['O','X','부담작업 없음','해당직종 없음','기타']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <vs-select autocomplete v-model="form.청소" class="w-full">
            <vs-select-item v-for="item in ['O','X','부담작업 없음','해당직종 없음','기타']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <vs-select autocomplete v-model="form.통학차량보조" class="w-full">
            <vs-select-item v-for="item in ['O','X','부담작업 없음','해당직종 없음','기타']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <vs-select autocomplete v-model="form.사무직종" class="w-full">
            <vs-select-item v-for="item in ['O','X','부담작업 없음','해당직종 없음','기타']" :key="item" :value="item" :text="item" />
          </vs-select>
        </td>
        <td>
          <ml-textarea v-model="form.비고" class="w-full" />
        </td>
      </tr>
      </tbody>
    </table>

    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" class="mt-28px" :is-print="isPrint" />

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        "stdInfo": {},
        "fileList": [],

        "fieldId": 0,

        '학교명': '',
        '소속지원청': '',
        '설립구분': '',
        '급': '',
        '실시일': '',
        '실시방법': '',

        '조리': '',
        '시설': '',
        '청소': '',
        '통학차량보조': '',
        '사무직종': '',

        '비고': '',
      },
    };
  },
  methods: {
    onSelectFieldSelector (value) {
      this.form.학교명 = value.field_name;
    }
  },
};
</script>

<style scoped lang="scss">
@counter-style styleDot {
  system: cyclic;
  symbols: "";
  prefix: "⦁ ";
  suffix: "";
}

.prefix-dot {
  list-style: styleDot;
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
}

table, th, td {
  border: 1px solid #CDCDCD;
  border-collapse: collapse;
}
th {
  text-align: center;
  background-color: #fafafa;
  padding: 16px 8px;
}
td {
  padding: 8px;
  vertical-align : top
}
</style>
